import axios from "axios";
import URLS from "../assets/json/texts.json";

const api = axios.create({
  baseURL:
    window.location.href.includes("localhost") ||
    window.location.href.includes("127.0.0.1") ||
    window.location.href.includes("10.5.41")
      ? URLS.STATIC_URL_DEV
      : window.location.href.includes("teste")
      ? URLS.STATIC_URL_TESTE
      : window.location.href.includes("alunos.fiecdev")
      ? URLS.STATIC_URL_PROD
      : null,
  timeout: 120000, // 2 minutos de timeout para upload de arquivos grandes
  maxContentLength: 50 * 1024 * 1024, // 50MB limite máximo para uploads
  maxBodyLength: 50 * 1024 * 1024, // 50MB limite máximo para o corpo da requisição
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export default api;
